export class MatterHistory {
  id: number;
  matter_id: number;
  matter_history_type_id: number = 1;
  message: string;
  is_deleted: boolean = false;
  created_at: string;
  updated_by: string;
  event_id: number;
  version: number;
  title: string;
  color_value: string;
  position: number;
  hidden: boolean;
  is_response: boolean;
  ancestry: string;
  notify_accounting: boolean = false;
  restored_by: number;
  restored_at: string;
  deleted_by: number;
  deleted_at: string;
  ancestry_depth: number = 0;
  billing_id: number;
  all_tags_list: string;
  reminder_date: string;
  reminder_start_date: string;
  reminder_date_struct: any;
  reminder_delivery_methods: Array<string> = [];
}
